export const PARCELS_PAGE_SIZE = 12;
export const HEADERS_FIELD_TOTAL_RESULTS = 'pagination-total-results';